import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

const Disclaimer = props => {
  return (
    <Modal isOpen={true} id="disclaimer-modal">
      <div className="modal-header p-3 bg-soft-secondary">
        <h5 className="modal-title" id="createboardModalLabel">
          Disclaimer
        </h5>
      </div>

      <ModalBody>
        <p className="text-muted m-0">
          Please Note: Meet & Greet and Airport Transfer Car Booking is to be made only for the Cardholders. No Guests should be booked.
        </p>
      </ModalBody>

      <ModalFooter className="pb-0">
        <div className="modal-footer mx-auto">
          <Button className="overlay-disable" color="primary" onClick={() => props.onClose()}>
            Confirm
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default Disclaimer;
